'use strict';

module.exports = (app) => app.controller('feShowParkedInvoicesTab', /* @ngInject */ function ($scope, $attrs, $http, apiConfig, parkedInvoiceService) {
    var apiUrl = apiConfig.$get().apiUrl;
    var accessToken = apiConfig.$get().accessToken;

    $scope.loaded = false;

    $scope.parkedInvoices = [];
    $scope.downloadFile = downloadFile;

    /**
     * Initialise variable after save page loaded
     * @param customerId
     */
    $scope.init = function (orderId) {
        $scope.loadParkedInvoicesByOrderId(orderId)
    };

    /**
     * load unite search result from api
     */
    $scope.loadParkedInvoicesByOrderId = function (orderId) {
        parkedInvoiceService.findByOrderId(orderId).then((parkedInvoices) => {
            $scope.parkedInvoices = parkedInvoices;
            $scope.loaded = true;
            $scope.$apply();
        }, (error) => {
            switch (error.status) {
                case 404:
                    $scope.parkedInvoices = [];
                    break;
                default:
                    console.error(error);
                    break;
            }
            $scope.loaded = true;
        })
    };

    function downloadFile(parkedInvoiceId) {
        if (!$scope.loading) {
            $scope.loading = true;
            parkedInvoiceService.downloadFile(parkedInvoiceId).then(() => {
                $scope.loading = false;
                $scope.$apply();
            })
        }
    }

});
